export const TEST_ID = 'accordion-qc'
export const HEADER_TEST_ID = 'accordion-qc-header'
export const CONTENT_TEST_ID = 'accordion-qc-content'
